<!-- <h1 mat-dialog-title>{{data.title}}</h1> -->

<div mat-dialog-content>
  <div class="main-section-box">

    <h5 class="modal_title">{{data.title}}</h5>

    <p [innerHTML]="data.subTitle"></p>

  </div>
</div>

<div mat-dialog-actions class="actions-btns" [ngClass]="{'btn-align-center': data.hideSaveBtn}">
  <button class="cancel-btn" mat-button (click)="closeModal()">Cancel</button>
  <button *ngIf="!data.hideSaveBtn" class="delete-btn" mat-button [mat-dialog-close]="true" cdkFocusInitial color="warn">{{data && data.rightBtnText ? data.rightBtnText : "Delete"}}</button>
</div>
